import { MigrateLayout } from '@/components/ui-new/containers/MigrateLayout';

export function MigratePage() {
  return <MigrateLayout />;
}
